<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="3">
            <a-form-model-item label="平台" prop="type">
              <a-select v-model="formInline.type" placeholder="请选择平台"  style="width: 100px;">
                <a-select-option value="1">美团</a-select-option>
                <a-select-option value="2">抖音</a-select-option>
                <a-select-option value="3">快手</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="门店名称" prop="store">
              <a-select  placeholder="请选择门店"  style="width: 300px;" v-model="formInline.store">
                <a-select-option 
                  v-for="(item,index) in storeList" 
                  :key="index"
                  :value="item.shopNo" 
                  :id="item.objId">
                  {{ item.name }}
                </a-select-option>
              
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="query">
                查询
              </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-col :span="6">
                <a-button style="margin-left: 10px" @click="resetForm">
                  重置
                </a-button>
              </a-col>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <thirdShopContent
          ref="aaa"
          :formInline="formInline"
          :storeList="storeList"
        ></thirdShopContent>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import thirdShopContent from '@/views/thirdShopManagementAdmin/thirdShopContentAdmin';
import { getStoreMessageAll } from "@/api/admin.js";
export default {
  components: {
    thirdShopContent,
  },
  data() {
    return {
      formInline: {
        store: "",
        type: "",

      },
      storeList: [],
    };
  },
  mounted() {
    if(this.cachedStoreList){
      this.storeList = this.cachedStoreList;
    }else{
      this.getStore();
    }
  },
  computed: {
    cachedStoreList() {
        return this.$store.state.storeList;
      }
  },

  methods: {
    handleSubmit() {
      console.log('sumbit:',this.formInline);
    },
    
    async getStore(){
      let res = await getStoreMessageAll();
      console.log('请求成功，返回数据:', res);
      if(res.code=="0" && res.data){
        this.storeList = res.data;
        console.log('门店列表:',this.storeList);
        this.$store.commit('setStoreList',this.storeList);
      }
    },

    resetForm() {
      this.formInline = {
        store: "",
        type: "",
      };
      // 重置子组件的数据
      if (this.$refs.aaa) {
        this.$refs.aaa.data = [];
        // 重置分页
        this.$refs.aaa.pagination.current = 1;
        // 重置表单
        this.$refs.ruleForm.resetFields();
      }
    },

    query() {
      this.$refs.aaa.search();
    },
   
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/thirdShopManagementAdmin/thirdShopHomeAdmin.vue